import { Nullable } from 'legacy/lut/classes/models/utils'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'

import {
  FormNumberInput,
  resetModifiedDataByField,
  updateInvalidData,
} from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'

interface IGoalProps {
  isRequired: boolean
  currency?: string
  valueType?: string
  initialValue: Nullable<number>
  className?: string
  formKey: string
  goalFieldName: string
  usePlaceholder?: boolean
}

export const Goal: FC<IGoalProps> = ({
  isRequired,
  initialValue,
  currency = '',
  valueType = '',
  className,
  formKey,
  goalFieldName,
  usePlaceholder,
}) => {
  const [previousGoalField, setPreviousGoalField] = useState('')
  const dispatch = useAppDispatch()

  const label = useMemo(() => {
    return `Goal, ${currency} ${valueType}`
  }, [currency, valueType])

  const handleValidate = useCallback(
    async (value: Nullable<number>) => {
      if (!isRequired) {
        return ''
      }

      if (value === null) {
        return 'This value is required'
      }

      return ''
    },
    [isRequired]
  )

  const resetField = useCallback(() => {
    dispatch(
      resetModifiedDataByField({
        formKey: formKey,
        field: previousGoalField,
      })
    )
    dispatch(
      updateInvalidData({
        key: formKey,
        field: previousGoalField,
        validationMessage: '',
      })
    )
  }, [dispatch, previousGoalField, formKey])

  useEffect(() => {
    if (previousGoalField !== goalFieldName) {
      resetField()
      setPreviousGoalField(goalFieldName)
    }
  }, [resetField, previousGoalField, goalFieldName])

  useEffect(() => {
    if (!isRequired) {
      dispatch(
        updateInvalidData({
          key: formKey,
          field: previousGoalField,
          validationMessage: '',
        })
      )
    }
  }, [isRequired, dispatch, previousGoalField, formKey])

  return (
    <FormNumberInput
      isRequired={isRequired}
      formKey={formKey}
      field={goalFieldName}
      defaultValue={initialValue}
      label={usePlaceholder ? '' : label}
      placeholder={usePlaceholder ? label : ''}
      className={className}
      onValidate={handleValidate}
      validationType={ValidationType.ONCHANGE}
    />
  )
}
